<template>
  <Form ref="attendanceRecordsForm" :model="attendanceRecords" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
    <FormItem :label="this.$t('ipms.attendance-user.userName.label')" prop="userName">
      <Input v-model="attendanceRecords.userName" :placeholder="$t('ipms.attendance-user.userName.holder')"  />
    </FormItem>
    <FormItem  :label="this.$t('ipms.attendance-records.attendanceType.label')" prop="attendanceType">
      <Select v-model="attendanceRecords.attendanceType" :placeholder="$t('ipms.attendance-records.attendanceType.holder')">
        <Option v-for="item in dict.attendanceType" :value="item.dictKey" :key="item.dictValue">{{item.dictValue }}</Option>
      </Select>
    </FormItem>
  </Form>
</template>
<script>
import api from '@/api'
import dict from '@/components/dict'
export default {
  dictParams: ['attendanceGroup','attendanceType','userPost','userCategory'],
  components: {
    'dict-tag': dict
  },
  data () {
    return {
      attendanceRecords: {
        id: null,
        userName:null,
        attendanceUserId: null,
        attendanceDate: null,
        attendanceType: null,
        attendanceGroup:null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['attendanceRecordsForm'].validate(valid => {
        if (valid) {
          if (this.attendanceRecords.id) {
            this.updateAttendanceRecords(this.attendanceRecords).then(then).error(error)
          } else {
            this.createAttendanceRecords(this.attendanceRecords).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.attendanceRecords.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['attendanceRecordsForm'].resetFields());
    },
    getAttendanceRecords(id,type){
      this.loading = true;
      this.$refs['attendanceRecordsForm'].resetFields()
      api.ipms.AttendanceRecords.detail(id).then(data => {
        this.attendanceRecords = data;
        this.attendanceRecords.attendanceType = parseInt(data.attendanceType);
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createAttendanceRecords(attendanceRecords){
      this.loading = true;
      return api.ipms.AttendanceRecords.add(attendanceRecords)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateAttendanceRecords(attendanceRecords){
      this.loading = true;
      return api.ipms.AttendanceRecords.update(attendanceRecords)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      attendanceUserId: [{type: 'number', required: true, message: this.$t('ipms.attendance-records.attendanceUserId.required'),trigger: 'blur'}],
      attendanceDate: [{type: 'date', required: true, message: this.$t('ipms.attendance-records.attendanceDate.required'),trigger: 'blur'}],
      //attendanceType: [{type: 'string', required: true, message: this.$t('ipms.attendance-records.attendanceType.required'),trigger: 'blur'}, {type: 'string',max: 50, message: this.$t('ipms.attendance-records.attendanceType.max'),trigger: 'blur'}],
      userName:[{type: 'string', required: true, message: this.$t('ipms.attendance-user.userName.required'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['attendanceRecordsForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
